export const supportPhoneNumber: string = '+1(866) 506-3454';
